<sc-main-toolbar>
  <!--  <h1>{{editorBlockTitle}}</h1>-->
</sc-main-toolbar>

<div class="mango-form-page-contents">
  <h1>{{ editorBlockTitle }}</h1>
  <sc-editor-block [id]="ttId"></sc-editor-block>
</div>
